<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">手机号</label>
          </div>
          <div class="weui-cell__bd">
            <p>{{mobile}}</p>
          </div>
        </div>
        <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
            <label class="weui-label">验证码</label>
          </div>
          <div class="weui-cell__bd">
            <input
              autofocus
              class="weui-input"
              type="text"
              pattern="[0-9]*"
              placeholder="请输入"
              maxlength="6"
              v-model="code"
            />
          </div>
          <div class="weui-cell__ft">
            <button
              class="weui-btn weui-btn_default weui-vcode-btn"
              @click="getVCode"
              :disabled="!!locktime"
            >
              <span v-if="locktime">{{locktime}}S</span>
              <span v-else>获取验证码</span>
            </button>
          </div>
        </div>
      </div>
      <div class="weui-cells__title">
        <span>密码须为8-20字符的英文、数字混合</span>
      </div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">新密码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="password" v-model="newPassword" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">确认密码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="password" v-model="verPassword" placeholder="请填写" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="resetPass">完成</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobile: String
  },
  data() {
    return {
      code: null,
      newPassword: null,
      verPassword: null,
      locktime: 0
    };
  },
  methods: {
    getVCode() {
      var me = this;
      if (me.locktime > 0) {
        return;
      }
      me.$loading({
        url: "/api/auth/password/reset_code",
        params: {
          mobile: me.mobile
        }
      })
        .then(function(res) {
          if (res.success) {
            me.$weui.toast("验证码已发送", 2000);
            me.updateLocktime();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("获取失败", 3000);
        });
    },
    /**
     * 锁定时间
     */
    updateLocktime() {
      var me = this;
      me.locktime = 60;
      var interval = setInterval(function() {
        me.locktime--;
        if (!me.locktime) {
          clearInterval(interval);
        }
      }, 1000);
    },
    /**
     * 重置密码
     */
    resetPass() {
      var me = this,
        code = me.code,
        password = me.newPassword;
      if (!code) {
        me.$weui.topTips("请填写验证码", 3000);
      } else if (!password) {
        me.$weui.topTips("请填写新密码", 3000);
      } else if (password != me.verPassword) {
        me.$weui.topTips("两次密码输入不一致", 3000);
      } else {
        me.$loading({
          url: "/api/auth/password/reset_by_mobile",
          method: "POST",
          params: {
            code,
            password,
            mobile: me.mobile
          }
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.go(-2);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      }
    }
  }
};
</script>